'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

exports.default = normalizeNumber;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function normalizeNumber(number) {
    var absolute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if ((0, _isString3.default)(number)) {
        if (number.substr(-1, 1) === '%') {
            number = (parseFloat(number) || 0) / 100 * absolute;
        } else if (number === 'left' || number === 'top') {
            number = 0;
        } else if (number === 'right' || number === 'bottom') {
            number = 1;
        } else if (number === 'middle' || number === 'center') {
            number = 0.5;
        } else {
            number = parseFloat(number) || 0;
        }
    }
    var absNumber = Math.abs(number);
    if (absNumber > 0 && absNumber <= 1) {
        number = number * absolute;
    }
    return number;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rumble-charts/lib/helpers/normalizeNumber.js
// module id = 100
// module chunks = 0